import React from "react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu";
import { Input } from "../../component/ui/input";
import { Button } from "../../component/ui/button";
import { Field, Form } from "react-final-form";

import {
  composeValidators,
  renderField,
  required,
} from "../../helpers/form-validations";
import { meta } from "eslint-plugin-prettier";
import { IoIosArrowDown } from "react-icons/io";
import { Label } from "../../component/ui/label";

const InvestorEditUser = () => {
  const onSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className="w-full flex flex-col p-6  bg-[#FFFFFF] rounded-md gap-8">
              <div className="flex w-full justify-between items-center gap-4 ">
                {/* Ticker name Input field */}
                <div className="gap-2 w-[49%] flex flex-col">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg "
                    htmlFor="portfolioNumber"
                  >
                    Portfolio Number
                  </Label>
                  <Field
                    id="portfolioNumber"
                    type="text"
                    name="portfolioNumber"
                    placeholder="Portfolio Number"
                    // validate={composeValidators(required)}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>

                <div className="gap-2 flex flex-col w-[49%]">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="investorName"
                  >
                    Investor Name
                  </Label>
                  <Field
                    id="investorName"
                    type="text"
                    name="investorName"
                    placeholder="Investor Name"
                    // validate={composeValidators(required)}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex w-full justify-between items-center gap-4 ">
                {/* Ticker name Input field */}
                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="email"
                  >
                    Email
                  </Label>
                  <Field
                    id="email"
                    type="text"
                    name="email"
                    placeholder="Enter Email"
                    // validate={composeValidators(required)}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>

                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="phoneNumber"
                  >
                    Phone Number
                  </Label>
                  <Field
                    id="phoneNumber"
                    type="text"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    // validate={composeValidators(required)}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex w-full justify-between items-center gap-4 ">
                {/* Ticker name Input field */}
                {/* Dropdown Menu */}
                <div className="flex flex-col  w-[49%] gap-2">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="scheme"
                  >
                    Scheme
                  </Label>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button
                        id="scheme"
                        variant="outline"
                        size="lg"
                        className="h-10 gap-1 w-full text-md flex border-[#3a5dd1] justify-between"
                      >
                        <span className="sr-only sm:not-sr-only">Scheme</span>
                        {/* Adding a down arrow */}
                        <span className="ml-1 text-[#0D215C]">
                          <IoIosArrowDown />
                        </span>
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                      className={"w-[var(--radix-dropdown-menu-trigger-width)]"}
                    >
                      <DropdownMenuLabel>Scheme Class</DropdownMenuLabel>
                      <DropdownMenuSeparator />
                      <DropdownMenuCheckboxItem checked>
                        Option 1
                      </DropdownMenuCheckboxItem>
                      <DropdownMenuCheckboxItem>
                        Option 2
                      </DropdownMenuCheckboxItem>
                      <DropdownMenuCheckboxItem>
                        Option 3
                      </DropdownMenuCheckboxItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>

                <div className="flex flex-col  w-[49%] gap-2">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="class"
                  >
                    Class
                  </Label>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button
                        id="class"
                        variant="outline"
                        size="lg"
                        className="h-10 gap-1 w-full text-md flex border-[#3a5dd1] justify-between"
                      >
                        <span className="sr-only sm:not-sr-only">Class</span>
                        {/* Adding a down arrow */}
                        <span className="ml-1 text-[#0D215C]">
                          <IoIosArrowDown />
                        </span>
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                      className={"w-[var(--radix-dropdown-menu-trigger-width)]"}
                    >
                      <DropdownMenuLabel>Scheme Class</DropdownMenuLabel>
                      <DropdownMenuSeparator />
                      <DropdownMenuCheckboxItem checked>
                        Option 1
                      </DropdownMenuCheckboxItem>
                      <DropdownMenuCheckboxItem>
                        Option 2
                      </DropdownMenuCheckboxItem>
                      <DropdownMenuCheckboxItem>
                        Option 3
                      </DropdownMenuCheckboxItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
              </div>

              <div className="flex w-full justify-between items-center gap-4 ">
                {/* Ticker name Input field */}
                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="numberOfUnit"
                  >
                    Number Of Unit
                  </Label>
                  <Field
                    id="numberOfUnit"
                    type="text"
                    name="numberOfUnit"
                    placeholder="Number Of Unit"
                    // validate={composeValidators(required)}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>

                <div className="gap-2 w-[49%] flex flex-col ">
                  <Label
                    className="text-start text-[#0D215C] font-bold text-lg"
                    htmlFor="faceValue"
                  >
                    Face Value
                  </Label>
                  <Field
                    id="faceValue"
                    type="text"
                    name="faceValue"
                    placeholder="Face Value"
                    // validate={composeValidators(required)}
                    component={renderField} // Correct usage of renderField
                    className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                  />
                  {/* Reserve space for the error message */}
                  {meta.touched && meta.error && (
                    <p className="text-red-500 text-sm text-left my-[2px]">
                      &nbsp;{meta.error}
                    </p>
                  )}
                </div>
              </div>

              <div className="w-full h-2 rounded-md bg-muted"></div>

              <div className=" w-full flex flex-col min-h-32">
                <div className=" flex flex-row justify-between">
                  <span className="text-start text-[#0D215C] font-bold text-lg">
                    Scheme Documents
                  </span>
                  <Button type="submit" className="w-[40%] bg-[#0D215C]  ">
                    Add Document
                  </Button>
                </div>
              </div>

              <div className="w-full h-2 rounded-md bg-muted"></div>

              <Button type="submit" className="w-[40%] bg-[#0D215C] self-end ">
                Update User
              </Button>
            </div>
          </form>
        )}
      />
    </>
  );
};

export default InvestorEditUser;
